<template>
  <ToastVue />
  <HeaderPanel />
  <div class="jtbd-app">
    <div class="jtbd-toolbar">
      <SelectVue
        :modelValue="lesson.id"
        :options="lessons"
        optionLabel="label"
        optionValue="id"
        placeholder="Сохранённые уроки"
        class="lesson-select"
        @update:modelValue="openSaved"
      />
      <ButtonVue type="button" label="Новый" severity="secondary" :disabled="busy" @click="createNew" />
      <ButtonVue type="button" label="Сохранить" :disabled="busy" @click="saveLesson" />
      <ButtonVue type="button" label="Скопировать HTML" severity="secondary" :disabled="busy" @click="copySnippet" />
    </div>

    <div class="jtbd-lesson" lang="ru">
      <div class="page">
        <article class="frame">
          <textarea ref="titleEl" v-model="lesson.title" class="frame-title frame-title-input" rows="1" placeholder="Название урока" @input="autoResizeTitle" />
          <div class="frame-lead">
            <Editor v-model="lesson.lead" editorStyle="min-height: 120px" />
          </div>

          <section class="card lectures">
            <h2 class="card-title">Эфиры и лекции</h2>
            <div class="lectures-grid">
              <article
                v-for="(item, index) in lesson.lectures"
                :key="item.id"
                class="item"
                :class="{ 'is-over': isDropOver('lectures', index) }"
                draggable="true"
                @dragstart="onDragStart('lectures', index, $event)"
                @dragover.prevent="onDragOver('lectures', index)"
                @drop.prevent="onDrop('lectures', index)"
                @dragend="onDragEnd"
              >
                <button type="button" class="item-edit" @pointerdown.stop @click.stop="openEdit('lectures', index)">Изменить</button>
                <img v-if="item.coverUrl" class="thumb thumb--round" :src="item.coverUrl" :alt="item.title" />
                <div v-else class="thumb thumb--round" role="img" :aria-label="item.title" />
                <h3 class="item-title">{{ item.title || 'Без названия' }}</h3>
                <p class="caption">{{ item.description }}</p>
              </article>
              <button type="button" class="add-card" aria-label="Добавить эфир" @click="openCreate('lectures')" @dragover.prevent @drop.prevent="onDropEnd('lectures')">
                <span class="thumb thumb--round add-thumb"><span class="add-circle" aria-hidden="true"></span></span>
              </button>
            </div>
          </section>

          <section class="card workshops">
            <h2 class="card-title">Воркшопы, бизнес-экскурсии и насмотренность</h2>
            <div class="workshops-row">
              <article
                v-for="(item, index) in lesson.workshops"
                :key="item.id"
                class="item"
                :class="{ 'is-over': isDropOver('workshops', index) }"
                draggable="true"
                @dragstart="onDragStart('workshops', index, $event)"
                @dragover.prevent="onDragOver('workshops', index)"
                @drop.prevent="onDrop('workshops', index)"
                @dragend="onDragEnd"
              >
                <button type="button" class="item-edit" @pointerdown.stop @click.stop="openEdit('workshops', index)">Изменить</button>
                <img v-if="item.coverUrl" class="thumb thumb--round" :src="item.coverUrl" :alt="item.title" />
                <div v-else class="thumb thumb--round" role="img" :aria-label="item.title" />
                <h3 class="item-title">{{ item.title || 'Без названия' }}</h3>
                <p class="caption">{{ item.description }}</p>
              </article>
              <button type="button" class="add-card" aria-label="Добавить воркшоп" @click="openCreate('workshops')" @dragover.prevent @drop.prevent="onDropEnd('workshops')">
                <span class="thumb thumb--round add-thumb"><span class="add-circle" aria-hidden="true"></span></span>
              </button>
            </div>
          </section>

          <section class="card materials">
            <h2 class="card-title">Материалы и доп.файлы</h2>
            <div class="materials-row">
              <article
                v-for="(item, index) in lesson.materials"
                :key="item.id"
                class="item"
                :class="{ 'is-over': isDropOver('materials', index) }"
                draggable="true"
                @dragstart="onDragStart('materials', index, $event)"
                @dragover.prevent="onDragOver('materials', index)"
                @drop.prevent="onDrop('materials', index)"
                @dragend="onDragEnd"
              >
                <button type="button" class="item-edit" @pointerdown.stop @click.stop="openEdit('materials', index)">Изменить</button>
                <img v-if="item.coverUrl" class="thumb" :src="item.coverUrl" :alt="item.title" />
                <div v-else class="thumb" role="img" :aria-label="item.title" />
                <h3 class="item-title">{{ item.title || 'Без названия' }}</h3>
              </article>
              <button type="button" class="add-card" aria-label="Добавить материал" @click="openCreate('materials')" @dragover.prevent @drop.prevent="onDropEnd('materials')">
                <span class="thumb add-thumb"><span class="add-circle" aria-hidden="true"></span></span>
              </button>
            </div>
          </section>

          <section class="card homework">
            <h2 class="card-title">Домашнее задание</h2>
            <div class="hw">
              <Editor v-model="lesson.homeworkHtml" editorStyle="min-height: 280px" />
            </div>
          </section>

          <section class="card field">
            <h2 class="card-title">Поле для ДЗ</h2>
            <textarea v-model="lesson.fieldNote" class="guide-text guide-input" rows="2" placeholder="Описание" />
            <textarea class="field-box" aria-label="Поле для домашнего задания" readonly tabindex="-1" />
          </section>

          <section class="card guide">
            <h2 class="card-title">Инструкция для работы в группе</h2>
            <textarea v-model="lesson.guide.description" class="guide-text guide-input" rows="2" placeholder="Описание" />
            <div class="materials-row">
              <article
                v-for="(item, index) in lesson.guide.materialsList"
                :key="item.id"
                class="item"
                :class="{ 'is-over': isDropOver('guideMaterials', index) }"
                draggable="true"
                @dragstart="onDragStart('guideMaterials', index, $event)"
                @dragover.prevent="onDragOver('guideMaterials', index)"
                @drop.prevent="onDrop('guideMaterials', index)"
                @dragend="onDragEnd"
              >
                <button type="button" class="item-edit" @pointerdown.stop @click.stop="openEdit('guideMaterials', index)">Изменить</button>
                <img v-if="item.coverUrl" class="thumb" :src="item.coverUrl" :alt="item.title" />
                <div v-else class="thumb" role="img" :aria-label="item.title" />
                <h3 class="item-title">{{ item.title || 'Без названия' }}</h3>
              </article>
              <button type="button" class="add-card" aria-label="Добавить материал" @click="openCreate('guideMaterials')" @dragover.prevent @drop.prevent="onDropEnd('guideMaterials')">
                <span class="thumb add-thumb"><span class="add-circle" aria-hidden="true"></span></span>
              </button>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>

  <DialogVue v-model:visible="dialog.open" modal :header="dialogTitle" :style="{ width: '32rem' }">
    <div class="dialog-form">
      <label v-if="!hideUrlField(dialog.section)">
        Ссылка
        <div class="url-row">
          <InputText v-model="dialog.draft.url" type="text" class="w-full" placeholder="https://" @blur="onUrlBlur" />
          <ButtonVue
            v-if="draftHasKinescope"
            type="button"
            label="Заполнить"
            severity="secondary"
            :disabled="dialog.uploading"
            @click="refreshVideoCard"
          />
        </div>
      </label>
      <label>
        Обложка (ссылка)
        <InputText v-model="dialog.draft.coverUrl" type="text" class="w-full" placeholder="https://" />
      </label>
      <label>
        Обложка (файл jpeg/png)
        <div class="cover-upload">
          <input
            ref="coverInput"
            class="cover-upload__input"
            type="file"
            accept="image/jpeg,image/png"
            :disabled="dialog.uploading"
            @change="onCoverFile"
          />
          <ButtonVue
            type="button"
            :label="dialog.uploading ? 'Загружаем…' : 'Выбрать файл'"
            icon="pi pi-image"
            severity="secondary"
            outlined
            :loading="dialog.uploading"
            :disabled="dialog.uploading"
            @click="pickCoverFile"
          />
          <span class="cover-upload__hint">
            {{ dialog.uploading ? 'Отправляем в хранилище GetCourse' : 'JPEG или PNG, до 5 МБ' }}
          </span>
        </div>
      </label>
      <img v-if="dialog.draft.coverUrl" class="cover-preview" :src="dialog.draft.coverUrl" alt="" />
      <label>
        Название
        <TextareaVue v-model="dialog.draft.title" rows="3" class="w-full" autoResize />
      </label>
      <label v-if="!hideDescription(dialog.section)">
        Описание
        <TextareaVue v-model="dialog.draft.description" rows="3" class="w-full" autoResize />
      </label>
    </div>
    <template #footer>
      <ButtonVue v-if="dialog.mode === 'edit'" type="button" label="Удалить" severity="danger" text @click="removeDraft" />
      <ButtonVue type="button" label="Отмена" severity="secondary" text @click="dialog.open = false" />
      <ButtonVue type="button" label="Готово" :disabled="dialog.uploading" @click="applyDraft" />
    </template>
  </DialogVue>

  <DialogVue v-model:visible="snippetOpen" modal header="HTML урока" :style="{ width: '48rem' }">
    <p class="snippet-hint">Буфер недоступен. Скопируйте фрагмент вручную.</p>
    <textarea v-model="snippetText" class="snippet-box" readonly spellcheck="false" />
  </DialogVue>
</template>

<script setup>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { useToast } from 'primevue/usetoast'
import Editor from 'primevue/editor'
import 'quill/dist/quill.snow.css'
import HeaderPanel from '@/components/HeaderPanel.vue'
import { useUserStore } from '@/stores/user'
import jtbdSnippet from '@/jtbd/buildSnippet'

const apiBase = 'https://ncht.bz'
const route = useRoute()
const router = useRouter()
const toast = useToast()
const userStore = useUserStore()

const lessons = ref([])
const busy = ref(false)
const snippetOpen = ref(false)
const snippetText = ref('')
const drag = ref(null)
const titleEl = ref(null)

const lesson = reactive(emptyLesson())
const dialog = reactive({
  open: false,
  section: 'lectures',
  mode: 'create',
  index: -1,
  uploading: false,
  draft: emptyItem()
})

const dialogTitle = computed(() => {
  const names = { lectures: 'Эфир', workshops: 'Воркшоп', materials: 'Материал', guideMaterials: 'Материал' }
  const name = names[dialog.section] || 'Карточка'
  return dialog.mode === 'edit' ? `Редактировать: ${name}` : `Добавить: ${name}`
})

const draftHasKinescope = computed(() => Boolean(kinescopeVideoId(dialog.draft.url)))

function sectionList(section) {
  return section === 'guideMaterials' ? lesson.guide.materialsList : lesson[section]
}

function hideDescription(section) {
  return section === 'materials' || section === 'guideMaterials'
}

/** У карточек инструкции ссылка не нужна — только обложка и название */
function hideUrlField(section) {
  return section === 'guideMaterials'
}

function emptyItem() {
  return { id: '', url: '', coverUrl: '', title: '', description: '' }
}

function emptyLesson() {
  return {
    id: null,
    title: '',
    lead: '',
    lectures: [],
    workshops: [],
    materials: [],
    homeworkHtml: '',
    fieldNote: '',
    guide: {
      title: 'Инструкция для работы в группе',
      description: '',
      materials: '',
      materialsList: []
    }
  }
}

function authHeaders() {
  return { Authorization: `Bearer ${userStore.token}` }
}

function applyRecord(row) {
  const payload = row && row.payload ? row.payload : {}
  const guide = payload.guide || {}
  lesson.id = row.id
  lesson.title = payload.title || ''
  lesson.lead = payload.lead || ''
  lesson.lectures = Array.isArray(payload.lectures) ? payload.lectures : []
  lesson.workshops = Array.isArray(payload.workshops) ? payload.workshops : []
  lesson.materials = Array.isArray(payload.materials) ? payload.materials : []
  lesson.homeworkHtml = payload.homeworkHtml || ''
  lesson.fieldNote = payload.fieldNote || ''
  lesson.guide.title = guide.title || ''
  lesson.guide.description = guide.description || ''
  lesson.guide.materials = typeof guide.materials === 'string' ? guide.materials : ''
  lesson.guide.materialsList = Array.isArray(guide.materialsList) ? guide.materialsList : []
}

function resetLesson() {
  const fresh = emptyLesson()
  lesson.id = null
  lesson.title = fresh.title
  lesson.lead = fresh.lead
  lesson.lectures = fresh.lectures
  lesson.workshops = fresh.workshops
  lesson.materials = fresh.materials
  lesson.homeworkHtml = fresh.homeworkHtml
  lesson.fieldNote = fresh.fieldNote
  lesson.guide.title = fresh.guide.title
  lesson.guide.description = fresh.guide.description
  lesson.guide.materials = fresh.guide.materials
  lesson.guide.materialsList = fresh.guide.materialsList
}

function payloadBody() {
  return {
    title: lesson.title,
    lead: lesson.lead,
    lectures: lesson.lectures,
    workshops: lesson.workshops,
    materials: lesson.materials,
    homeworkHtml: lesson.homeworkHtml,
    fieldNote: lesson.fieldNote,
    guide: { ...lesson.guide }
  }
}

function ensureLessonCss() {
  if (document.getElementById('jtbd-lesson-css')) return
  const el = document.createElement('style')
  el.id = 'jtbd-lesson-css'
  el.textContent = jtbdSnippet.lessonCss
  document.head.appendChild(el)
}

async function refreshList() {
  const { data } = await axios.get(`${apiBase}/api/jtbd/lessons`, { headers: authHeaders() })
  lessons.value = (data || []).map((row) => ({
    id: row.id,
    title: row.title,
    label: row.title || 'Без названия'
  }))
}

async function loadRoute(id) {
  if (!id) {
    resetLesson()
    return
  }
  if (id === lesson.id) return
  const { data } = await axios.get(`${apiBase}/api/jtbd/lessons/${id}`, { headers: authHeaders() })
  applyRecord(data)
}

async function saveLesson() {
  busy.value = true
  try {
    if (lesson.id) {
      const { data } = await axios.put(`${apiBase}/api/jtbd/lessons/${lesson.id}`, payloadBody(), { headers: authHeaders() })
      applyRecord(data)
    } else {
      const { data } = await axios.post(`${apiBase}/api/jtbd/lessons`, payloadBody(), { headers: authHeaders() })
      applyRecord(data)
      await router.replace(`/jtbd/${data.id}`)
    }
    await refreshList()
    toast.add({ severity: 'success', summary: 'Сохранено', life: 2000 })
    return true
  } catch (error) {
    toast.add({ severity: 'error', summary: 'Не удалось сохранить', detail: error.message, life: 4000 })
    return false
  } finally {
    busy.value = false
  }
}

async function copySnippet() {
  const saved = await saveLesson()
  if (!saved) return
  const html = jtbdSnippet.buildSnippet(payloadBody())
  try {
    await navigator.clipboard.writeText(html)
    toast.add({ severity: 'success', summary: 'HTML скопирован', life: 2500 })
  } catch (error) {
    snippetText.value = html
    snippetOpen.value = true
  }
}

function createNew() {
  resetLesson()
  if (route.params.id) router.push('/jtbd')
}

function openSaved(id) {
  if (!id || id === lesson.id) return
  router.push(`/jtbd/${id}`)
}

function openCreate(section) {
  dialog.section = section
  dialog.mode = 'create'
  dialog.index = -1
  dialog.uploading = false
  dialog.draft = { ...emptyItem(), id: crypto.randomUUID() }
  dialog.open = true
}

function openEdit(section, index) {
  const item = sectionList(section)[index]
  dialog.section = section
  dialog.mode = 'edit'
  dialog.index = index
  dialog.uploading = false
  dialog.draft = {
    id: item.id,
    url: item.url || '',
    coverUrl: item.coverUrl || '',
    title: item.title || '',
    description: item.description || ''
  }
  dialog.open = true
}

/** Служебные сегменты пути в ссылках Kinescope — не являются id видео */
const KINESCOPE_PATH_KEYWORDS = ['video', 'videos', 'embed', 'detail', 'player', 'watch', 'edit']

function kinescopeVideoId(link) {
  const value = String(link || '').trim()
  if (!/^https?:\/\//i.test(value)) return ''
  let url
  try {
    url = new URL(value)
  } catch {
    return ''
  }
  if (!/(^|\.)kinescope\.io$/i.test(url.hostname)) return ''
  const fromQuery = url.searchParams.get('video_id') || url.searchParams.get('videoId') || url.searchParams.get('id')
  if (fromQuery) return fromQuery
  // Формы ссылок: /{id}, /{id}/plyXXXX, /embed/{id}, /video/{id}
  // и ссылка из личного кабинета https://app.kinescope.io/video/detail/{uuid}
  const parts = url.pathname.split('/').filter(Boolean)
  for (const part of parts) {
    if (KINESCOPE_PATH_KEYWORDS.indexOf(part.toLowerCase()) !== -1) continue
    if (/^ply[a-zA-Z0-9_-]*$/i.test(part)) continue
    if (/^[a-zA-Z0-9_-]{6,}$/.test(part)) return part
  }
  return ''
}

/** Похоже ли на uuid (в таких ссылках Kinescope плеер не работает) */
function isUuidLike(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(value || '').trim())
}

/**
 * Kinescope отдаёт по uuid ещё и короткий id (в play_link). Плеер понимает только короткий,
 * поэтому ссылку в черновике приводим к канонической короткой; в сниппет она попадает уже такой.
 * @returns {boolean} true, если ссылку пришлось заменить
 */
function applyKinescopeShortUrl(payload) {
  const shortId = String(payload?.videoId || '').trim() || kinescopeVideoId(payload?.playLink || '')
  if (!shortId || isUuidLike(shortId)) return false
  if (kinescopeVideoId(dialog.draft.url) === shortId) return false
  dialog.draft.url = `https://kinescope.io/${shortId}`
  return true
}

async function onUrlBlur() {
  const titleEmpty = !String(dialog.draft.title || '').trim()
  const descriptionEmpty = !String(dialog.draft.description || '').trim()
  const coverEmpty = !String(dialog.draft.coverUrl || '').trim()
  const videoId = kinescopeVideoId(dialog.draft.url)
  if (!videoId) return
  // если ссылка uuid-вида — метаданные нужны всё равно: надо добыть короткий id для плеера
  if (!isUuidLike(videoId) && !titleEmpty && !descriptionEmpty && !coverEmpty) return
  try {
    const { data } = await axios.get(`${apiBase}/api/kinescope-videos/${encodeURIComponent(videoId)}`)
    const raw = data?.data ?? data ?? {}
    if (titleEmpty && raw.title) dialog.draft.title = String(raw.title)
    if (!hideDescription(dialog.section) && descriptionEmpty && raw.description) {
      dialog.draft.description = String(raw.description)
    }
    if (coverEmpty && raw.coverUrl) dialog.draft.coverUrl = String(raw.coverUrl)
    applyKinescopeShortUrl(raw)
  } catch (error) {
    const detail = error?.response?.status === 404 ? 'Видео не найдено' : 'Не удалось прочитать карточку видео'
    toast.add({ severity: 'warn', summary: 'Kinescope', detail, life: 3000 })
  }
}

async function refreshVideoCard() {
  const videoId = kinescopeVideoId(dialog.draft.url)
  if (!videoId) return
  try {
    const { data } = await axios.get(`${apiBase}/api/kinescope-videos/${encodeURIComponent(videoId)}`)
    const raw = data?.data ?? data ?? {}
    if (raw.title != null) dialog.draft.title = String(raw.title)
    if (raw.coverUrl != null) dialog.draft.coverUrl = String(raw.coverUrl)
    if (!hideDescription(dialog.section) && raw.description != null) {
      dialog.draft.description = String(raw.description)
    }
    const replaced = applyKinescopeShortUrl(raw)
    toast.add({
      severity: 'success',
      summary: replaced ? 'Ссылка заменена на короткую' : 'Карточка видео обновлена',
      detail: replaced ? 'Короткий id нужен, чтобы работал плеер в попапе' : undefined,
      life: 3000
    })
  } catch (error) {
    const detail = error?.response?.status === 404 ? 'Видео не найдено' : 'Не удалось прочитать карточку видео'
    toast.add({ severity: 'warn', summary: 'Kinescope', detail, life: 3000 })
  }
}

function applyDraft() {
  const next = {
    id: dialog.draft.id || crypto.randomUUID(),
    url: dialog.draft.url || '',
    coverUrl: dialog.draft.coverUrl || '',
    title: dialog.draft.title || ''
  }
  if (!hideDescription(dialog.section)) next.description = dialog.draft.description || ''
  const list = sectionList(dialog.section)
  if (dialog.mode === 'edit' && dialog.index >= 0) list.splice(dialog.index, 1, next)
  else list.push(next)
  dialog.open = false
}

function removeDraft() {
  if (dialog.mode === 'edit' && dialog.index >= 0) sectionList(dialog.section).splice(dialog.index, 1)
  dialog.open = false
}

const coverInput = ref(null)

function pickCoverFile() {
  const input = coverInput.value
  if (input && !dialog.uploading) input.click()
}

async function onCoverFile(event) {
  const file = event.target.files && event.target.files[0]
  event.target.value = ''
  if (!file) return
  const form = new FormData()
  form.append('file', file)
  dialog.uploading = true
  try {
    const { data } = await axios.post(`${apiBase}/api/jtbd/covers`, form, { headers: authHeaders() })
    dialog.draft.coverUrl = data.url
  } catch (error) {
    toast.add({ severity: 'error', summary: 'Обложка не загрузилась', detail: error.message, life: 4000 })
  } finally {
    dialog.uploading = false
  }
}

function onDragStart(section, index, event) {
  drag.value = { section, from: index, over: null }
  event.dataTransfer.effectAllowed = 'move'
  event.dataTransfer.setData('text/plain', `${section}:${index}`)
}

function onDragOver(section, index) {
  if (!drag.value || drag.value.section !== section) return
  drag.value = { ...drag.value, over: index }
}

function onDrop(section, index) {
  if (!drag.value || drag.value.section !== section) return
  const list = sectionList(section)
  const from = drag.value.from
  drag.value = null
  if (from === index) return
  const [item] = list.splice(from, 1)
  list.splice(index, 0, item)
}

function onDropEnd(section) {
  if (!drag.value || drag.value.section !== section) return
  const list = sectionList(section)
  const from = drag.value.from
  drag.value = null
  if (from === list.length - 1) return
  const [item] = list.splice(from, 1)
  list.push(item)
}

function onDragEnd() {
  drag.value = null
}

function isDropOver(section, index) {
  return !!(drag.value && drag.value.section === section && drag.value.over === index && drag.value.from !== index)
}

function autoResizeTitle() {
  const el = titleEl.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = `${el.scrollHeight}px`
}

watch(() => route.params.id, (id) => {
  loadRoute(id).catch((error) => {
    toast.add({ severity: 'error', summary: 'Урок не открылся', detail: error.message, life: 4000 })
  })
})

watch(() => lesson.title, () => nextTick(autoResizeTitle))

onMounted(async () => {
  ensureLessonCss()
  try {
    await refreshList()
    await loadRoute(route.params.id)
  } catch (error) {
    toast.add({ severity: 'error', summary: 'JTBD недоступен', detail: error.message, life: 4000 })
  }
})
</script>

<style scoped>
.jtbd-app {
  min-height: 100vh;
  background: #ececec;
}
.jtbd-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  max-width: 1301px;
  margin: 0 auto;
  padding: 16px 16px 0;
}
.lesson-select { min-width: 260px; }
.frame-title-input,
.frame-lead-input,
.guide-input {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  padding: 0;
  resize: vertical;
}
.frame-title-input { overflow: hidden; resize: none; }
.frame-lead :deep(.ql-editor) {
  font-size: 20px;
  line-height: 1.15;
  min-height: 120px;
}
.frame-title-input:focus,
.frame-lead-input:focus,
.guide-input:focus {
  outline: 1px dashed #c8c8c8;
  outline-offset: 4px;
}
.item { position: relative; cursor: grab; }
.item.is-over { outline: 2px solid #000; outline-offset: 4px; }
.item-edit {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  border: 0;
  border-radius: 999px;
  padding: 4px 10px;
  background: #000;
  color: #fff;
  font: 12px/1.2 Inter, sans-serif;
  cursor: pointer;
  opacity: 0;
}
.item:hover .item-edit,
.item:focus-within .item-edit { opacity: 1; }
.add-card {
  display: block;
  width: 100%;
  min-width: 0;
  align-self: start;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.add-thumb {
  position: relative;
}
.add-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  transform: translate(-50%, -50%);
}
.add-circle::before,
.add-circle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background: #e4e4e4;
  border-radius: 999px;
  transform: translate(-50%, -50%);
}
.add-circle::before {
  width: 40px;
  height: 8px;
}
.add-circle::after {
  width: 8px;
  height: 40px;
}
.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.dialog-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
}
.url-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.url-row .w-full { flex: 1 1 auto; min-width: 0; }
.caption { white-space: pre-line; }
.w-full { width: 100%; }
.cover-preview {
  width: 160px;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 12px;
  background: #e4e4e4;
}
.cover-upload {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  flex-wrap: wrap;
}
.cover-upload__input {
  display: none;
}
.cover-upload__hint {
  font-size: 12px;
  line-height: 1.3;
  color: #7a7a7a;
}
.snippet-hint { margin: 0 0 8px; }
.snippet-box {
  width: 100%;
  min-height: 320px;
  font: 12px/1.4 ui-monospace, monospace;
}
</style>
